import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBM14JoBloJTfS9YPNxLPWsOKWCMXjI6Bw",
  authDomain: "hellodoctor-64862.firebaseapp.com",
  projectId: "hellodoctor-64862",
  storageBucket: "hellodoctor-64862.firebasestorage.app",
  messagingSenderId: "739473787782",
  appId: "1:739473787782:web:81ee5b7cc132fd01c47a07",
  measurementId: "G-XYGP5QM82E"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage(app);